import axiosClient, { unwrap } from "./axiosClient";
import { ENDPOINTS } from "./endpoints";

export const stockApi = {
  // Batches
  journey: (source, batchId) =>
    axiosClient.get(ENDPOINTS.stock.journey(source, batchId)).then(unwrap),
  getAll: () => axiosClient.get(ENDPOINTS.stock.list).then(unwrap),
  getAdjustableBatches: () => axiosClient.get(ENDPOINTS.stock.adjustableBatches).then(unwrap),
  create: (data) => axiosClient.post(ENDPOINTS.stock.create, data).then(unwrap),
  bulkCreate: (data) =>
    axiosClient.post(ENDPOINTS.stock.bulkCreate, data).then(unwrap),
  update: (batchId, data) => axiosClient.put(ENDPOINTS.stock.update(batchId), data).then(unwrap),
  remove: (batchId) => axiosClient.delete(ENDPOINTS.stock.delete(batchId)).then(unwrap),
  // Adjustments
  adjust: (data) => axiosClient.post(ENDPOINTS.stock.adjustments, data).then(unwrap),
  listAdjustments: () => axiosClient.get(ENDPOINTS.stock.adjustments).then(unwrap),
  updateAdjustment: (id, data) => axiosClient.put(ENDPOINTS.stock.adjustmentUpdate(id), data).then(unwrap),
  removeAdjustment: (id) => axiosClient.delete(ENDPOINTS.stock.adjustmentDelete(id)).then(unwrap),
  // Low stock
  lowStock: () => axiosClient.get(ENDPOINTS.stock.lowStock).then(unwrap),
};
